<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>

        <li class="breadcrumb-item active" aria-current="page">
            <a routerLink="/sample" style="color: #003E53;">Samples</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            <a style="color: #003E53;">Assign</a>
        </li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center gx-2">
                <div class="col-10 col-md-6 d-flex flex-column">
                    <h6 class="mb-1 fw-semibold d-flex align-items-center">
                        <i class="bi bi-box-seam me-2"></i>
                        Issue <span class="text-dark ms-1">{{ sampleData?.name }}</span>&nbsp; to Distributors
                    </h6>
                    <small class="fw-semibold text-muted d-flex align-items-center">
                        <i class="bi bi-archive me-1"></i>
                        In Stock: {{ sampleData?.leftItems }}
                    </small>
                </div>

                <div class="col-2 col-md-6 d-flex justify-content-end">
                    <button type="button" (click)="openModel()"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        title="Assign Sample" style="width: 22px; height: 22px;">
                        <mat-icon fontIcon="add" class="d-flex align-items-center justify-content-center"></mat-icon>
                    </button>
                </div>
            </div>



            <hr class="m-0 p-0">
            <hr class="m-0 p-0">

            <div class="card-body">
                <mat-tab-group [selectedIndex]="0" (selectedIndexChange)="onTabChange($event)"
                    animationDuration="500ms">
                    <!-- .............Wholoesaler Tab.................................... -->
                    <mat-tab label="Wholesaler">
                        <div class="table-responsive mt-1">
                            <div class="mat-elevation-z8">
                                <table mat-table [dataSource]="wholeSalerdataSource"
                                    class="text-nowrap table-bordered compact-table">
                                    <ng-container matColumnDef="srno">
                                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                        <td mat-cell *matCellDef="let row; let index = index">{{ index + 1 +
                                            (wholeSalerPaginator.pageIndex * wholeSalerPaginator.pageSize) }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef> Name </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.receiverDistributorId?.name}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="issued">
                                        <th mat-header-cell *matHeaderCellDef>Issued</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.quantityAssigned}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="remainingInventory">
                                        <th mat-header-cell *matHeaderCellDef> Remaining Inventory </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.quantityRemaining}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="limit">
                                        <th mat-header-cell *matHeaderCellDef width="150px"> Limit </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="d-flex align-items-center">
                                                <input type="number" class="form-control form-control-sm py-1"
                                                    [disabled]="!element.limitEditMode"
                                                    [(ngModel)]="element.distributorLimit" placeholder="0" min="1" />
                                                @if (!element.limitEditMode) {
                                                <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit"
                                                    class="c_btn ms-1" (click)="enableLimitEdit(element)"></mat-icon>
                                                }
                                                @else {
                                                <mat-icon aria-hidden="false" aria-label="Save icon" fontIcon="save"
                                                    class="c_btn mt-1 ms-1" (click)="saveLimitEdit(element)"></mat-icon>
                                                }
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="issue">
                                        <th mat-header-cell *matHeaderCellDef width="150px"> Issue </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="d-flex align-items-center">
                                                <input type="number" class="form-control form-control-sm py-1"
                                                    [disabled]="!element.editMode"
                                                    [(ngModel)]="newQuantityAssignedMap[element._id]" placeholder="0"
                                                    min="1" />

                                                @if (!element.editMode) {
                                                <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit"
                                                    class="c_btn ms-1" (click)="enableEdit(element)"></mat-icon>
                                                }
                                                @else {
                                                <mat-icon aria-hidden="false" aria-label="Save icon" fontIcon="save"
                                                    class="c_btn mt-1 ms-1" (click)="saveEdit(element)"></mat-icon>
                                                }
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head">
                                    </tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                            No data available
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <mat-paginator #wholeSalerPaginator [length]="wholeSalerTotal" [pageSize]="10"
                            (page)="getAllIssuedSampleToWholeSaler($event)"></mat-paginator>
                    </mat-tab>

                    <mat-tab label="Retailer">
                        <div class="table-responsive mt-1">
                            <div class="mat-elevation-z8">
                                <table mat-table [dataSource]="retailerDataSource"
                                    class="text-nowrap table-bordered compact-table ">
                                    <ng-container matColumnDef="srno">
                                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                        <td mat-cell *matCellDef="let row; let index = index">{{ index + 1 +
                                            (wholeSalerPaginator.pageIndex * wholeSalerPaginator.pageSize) }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef> Name </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.receiverDistributorId?.name}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="issued">
                                        <th mat-header-cell *matHeaderCellDef>Issued</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.quantityAssigned}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="remainingInventory">
                                        <th mat-header-cell *matHeaderCellDef> Remaining Inventory </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element.quantityRemaining}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="limit">
                                        <th mat-header-cell *matHeaderCellDef width="150px"> Limit </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="d-flex align-items-center">
                                                <input type="number" class="form-control form-control-sm py-1"
                                                    [disabled]="!element.limitEditMode"
                                                    [(ngModel)]="element.distributorLimit" placeholder="0" min="1" />

                                                @if (!element.limitEditMode) {
                                                <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit"
                                                    class="c_btn ms-1" (click)="enableLimitEdit(element)"></mat-icon>
                                                }
                                                @else {
                                                <mat-icon aria-hidden="false" aria-label="Save icon" fontIcon="save"
                                                    class="c_btn mt-1 ms-1" (click)="saveLimitEdit(element)"></mat-icon>
                                                }
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="issue">
                                        <th mat-header-cell *matHeaderCellDef width="150px"> Issue </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="d-flex align-items-center">
                                                <input type="number" class="form-control form-control-sm py-1"
                                                    [disabled]="!element.editMode"
                                                    [(ngModel)]="newQuantityAssignedMap[element._id]" placeholder="0"
                                                    min="1" />

                                                @if (!element.editMode) {
                                                <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit"
                                                    class="c_btn ms-1" (click)="enableEdit(element)"></mat-icon>
                                                }
                                                @else {
                                                <mat-icon aria-hidden="false" aria-label="Save icon" fontIcon="save"
                                                    class="c_btn mt-1 ms-1" (click)="saveEdit(element)"></mat-icon>
                                                }
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                            No data available
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <mat-paginator #retailerPaginator [length]="retailerTotal" [pageSize]="10"
                            (page)="getAllIssuedSampleToRetailer($event)"></mat-paginator>
                    </mat-tab>
                    <!-- .............Retailer Tab End.................................... -->
                </mat-tab-group>
            </div>
        </app-card>
    </div>
</div>





<div class="modal fade" id="assignSampleModal" tabindex="-1" aria-labelledby="assignSampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen custom-light-modal">
        <div class="modal-content">
            <div class="modal-header border-0 pb-0 flex-column align-items-start">
                <h6 class="mb-1 fw-semibold d-flex align-items-center">
                    <i class="bi bi-box-seam me-2"></i>
                    Issue <span class="text-dark ms-1">{{ sampleData?.name }}</span> &nbsp; to
                    <span class="text-muted ms-2">
                        <strong>
                            @if(currentTabIndex == 0) {
                            Wholesalers
                            } @else {
                            Retailers
                            }
                        </strong>
                    </span>
                </h6>


                <div class="mt-1 px-3 py-1 rounded fw-medium" [ngClass]="{
                    'bg-success text-white': sampleData?.leftItems > 0,
                    'bg-danger text-white': sampleData?.leftItems === 0
                    }">
                    Available Stock: {{ sampleData?.leftItems ?? 0 }}
                </div>

                <!-- Close Button -->
                <button type="button" class="btn-close position-absolute end-0 top-0 m-3"
                    (click)="hideModel()"></button>
            </div>

            <div class="modal-body pt-1">
                <div class="row">
                  
                    <div class="col-12 col-md-5">
                        <mat-card class="mt-2 h-100">
                            <mat-card-content class="d-flex flex-column" style="height: 80vh;">
                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h5 class="mb-0 fw-bold">Distributors List</h5>
                                    <button type="button"
                                        class="btn btn-sm btn-outline-primary rounded-2 d-flex align-items-center gap-1"
                                        (click)="selectAllSamples()">Select All</button>
                                </div>

                                <!-- Search -->
                                <div class="row g-2 flex-wrap d-flex align-items-end mb-2">
                                    <div class="col-12">
                                        <mat-form-field class="dense w-100">
                                            <mat-label>Sample Name</mat-label>
                                            <input matInput [(ngModel)]="distributorSearch.name" name="name"
                                                (input)="onNameInputChange($event)">
                                        </mat-form-field>
                                    </div>
                                </div>

                           
                                <div class="table-responsive flex-grow-1 overflow-y-auto" style="overflow-x: hidden;">
                                    <div class="mat-elevation-z8">
                                        <table mat-table [dataSource]="distributorsDataSource"
                                            class="table-bordered compact-table w-100" style="table-layout: fixed;">

                                            <!-- Columns -->
                                            <ng-container matColumnDef="name">
                                                <th mat-header-cell *matHeaderCellDef class="text-center">Name</th>
                                                <td mat-cell *matCellDef="let element">
                                                    <div class="fw-medium">{{ element?.distributorId?.name }}</div>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="email">
                                                <th mat-header-cell *matHeaderCellDef class="text-center">Email</th>
                                                <td mat-cell *matCellDef="let element">{{ element?.distributorId?.email
                                                    }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="action">
                                                <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                                                <td mat-cell *matCellDef="let element">
                                                    <div class="d-flex align-items-center justify-content-center mx-2">
                                                        <button type="button" (click)="addRow(element)"
                                                            class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                                                            style="width: 20px; height: 20px;">
                                                            <mat-icon fontIcon="add"
                                                                class="d-flex align-items-center justify-content-center"></mat-icon>
                                                        </button>
                                                    </div>
                                                </td>
                                            </ng-container>

                                  
                                            <tr mat-header-row *matHeaderRowDef="distributorsdisplayedColumns"
                                                class="t_head sticky"></tr>
                                            <tr mat-row *matRowDef="let row; columns: distributorsdisplayedColumns;">
                                            </tr>

                              
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell text-center"
                                                    [attr.colspan]="distributorsdisplayedColumns.length">
                                                    No data available
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <!-- RIGHT PANEL -->
                    <div class="col-12 col-md-7">
                        <form [formGroup]="issueSampleForm" (ngSubmit)="submitRows(null)">
                            <mat-card class="mt-2 d-flex flex-column" style="height: 80vh;">
                                <!-- Scrollable rows -->
                                <mat-card-content class="flex-grow-1 overflow-auto pe-2">
                                    @if (rows.controls.length === 0) {
                                    <div class="text-muted">No Distributor selected yet.</div>
                                    } @else {
                                    <div formArrayName="rows">
                                       @for (sample of rows.controls; track sample){

                                        <div [formGroupName]="$index" class="border rounded p-2 mb-2">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="flex-grow-1">
                                                    <div class="fw-semibold text-dark">{{
                                                        sample.get('distributorName')?.value }}</div>
                                                    <small class="text-muted">{{ sample.get('distributorEmail')?.value
                                                        }}</small>
                                                </div>
                                                <button type="button" (click)="removeRow($index)"
                                                    class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                                                    style="width: 20px; height: 20px;">
                                                    <mat-icon fontIcon="close"
                                                        class="d-flex align-items-center justify-content-center"></mat-icon>
                                                </button>
                                            </div>

                                            <div class="row mt-2 gx-2">
                                                <div class="col-6">
                                                    <input type="number" class="form-control form-control-sm py-1"
                                                        placeholder="Enter Quantity" formControlName="quantityAssigned"
                                                        min="1">
                                                    @if (sample.get('quantityAssigned')?.invalid &&
                                                    sample.get('quantityAssigned')?.dirty) {
                                                    <div class="text-danger small">Enter valid quantity.</div>
                                                    } @else {
                                                    <small class="text-muted">Qty</small>
                                                    }
                                                </div>
                                                <div class="col-6">
                                                    <input type="number" class="form-control form-control-sm py-1"
                                                        placeholder="Enter Limit" formControlName="distributorLimit">
                                                    @if (sample.get('distributorLimit')?.invalid &&
                                                    sample.get('distributorLimit')?.dirty) {
                                                    <div class="text-danger small">You cannot assign less than the
                                                        default limit.</div>
                                                    } @else {
                                                    <small class="text-muted">Limit</small>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    }
                                </mat-card-content>

                                <!-- Fixed Save Button -->
                                @if (rows.controls.length > 0) {
                                <mat-card-actions
                                    class="d-flex justify-content-between align-items-center border-top pt-2 mt-2 bg-white sticky-bottom">
                                    <div class="text-muted d-flex align-items-center">
                                        <i class="bi bi-list-check me-1"></i>
                                        {{ rows.controls.length }} selected
                                    </div>
                                    <button type="submit" class="btn btn-sm btn-primary rounded-2"
                                        [disabled]="issueSampleForm.invalid">
                                        Save
                                    </button>
                                </mat-card-actions>
                                }
                            </mat-card>
                        </form>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>